import React, {
  MouseEvent,
} from 'react';
import Button from 'pages/Dashboard/components/Button';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

type Props = {
  label: string;
  count: number;
  showInactive: boolean;
  onToggle: () => void;
};

export default function InactiveOptionsToggle({
  label,
  count,
  showInactive,
  onToggle,
}: Props) {
  const Icon = showInactive ? ArrowDropUpIcon : ArrowDropDownIcon;

  return (
    <Button
      className="!hover:bg-transparent !font-medium !italic !opacity-80 !p-2 !max-w-none !w-full !justify-start flex gap-0.5 items-center"
      variant="text"
      onClick={(event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        onToggle();
      }}
    >
      <Icon className="!w-4 !h-4" />
      {`${showInactive ? 'Hide' : 'Show'} inactive ${label} (${count})`}
    </Button>
  );
}
